import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";

import Loading from "../../../components/Loading";
import PlantsTabComponent from "../../../components/ScheduleConfig/PlantsTabComponent";

import useStyles from "./styles";
import { getDataStorage } from "../../../utils/filterManagementDataStore";

const Plants = ({
  plants,
  branches,
  filter,
  setFilter,
  loadPlants,
  loadReservationTypes,
  reservationTypes,
  deletePlant,
  addPlant,
  updatePlant,
  subRoutes,
  plantsLoading,
  plantsError,
  clearPlantErrors,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();

  const removeItem = (data) => deletePlant(data);
  const addItem = (plantData) => addPlant(plantData);
  const updateItem = (plantData) => updatePlant(plantData);
  const getNotifications = () => getNotificationsFromSchedConfigAsync();

  const [plantsState, setPlantsState] = useState([]);

  useEffect(() => {
    setPlantsState(plants);
  }, [plants, setPlantsState]);

  useEffect(() => {
    loadReservationTypes();
  }, [loadReservationTypes]);

  useEffect(() => {
    const branch = filter.plant_branch || getDataStorage('plant_config_checkSingleBranch')?.value;
    if (branch) {
      loadPlants(branch);
    } else {
      setPlantsState([]);
    }

  }, [loadPlants, filter.plant_branch, setPlantsState]);

  return (
    <div className={classes.root}>
      {plantsLoading && <Loading />}
      <PlantsTabComponent
        subRoutes={subRoutes}
        branches={branches}
        filter={filter}
        setFilter={setFilter}
        plants={plantsState}
        onDeleteItem={removeItem}
        onAddItem={addItem}
        onUpdateItem={updateItem}
        reservationTypes={reservationTypes}
        plantsError={plantsError}
        clearPlantErrors={clearPlantErrors}
        getNotificationsFromSchedConfigAsync={getNotifications}
      />
    </div>
  );
};

const mapStateToProps = ({
    plants: { plants, loading, error },
    notifications,
    scheduling
  }) => ({
  plants,
  plantsLoading: loading,
  plantsError: error,
  reservationTypes: scheduling.reservationTypes,
  notifications: notifications.allNotifications
});

const mapDispatch = (dispatch) => ({
  loadPlants: (branchId) => dispatch.plants.loadAsync(branchId),
  deletePlant: (data) => dispatch.plants.deleteAsync(data),
  loadReservationTypes: (id) => dispatch.scheduling.getReservationTypesAsync(),
  addPlant: (data) => dispatch.plants.addAsync(data),
  updatePlant: (data) => dispatch.plants.updateAsync(data),
  clearPlantErrors: (payload) => dispatch.plants.clearPlantErrors(payload),
  getNotificationsFromSchedConfigAsync: () => dispatch.notifications.getNotificationsFromSchedConfigAsync()
});

Plants.propTypes = {
  plants: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  loadPlants: PropTypes.func.isRequired,
  deletePlant: PropTypes.func.isRequired,
  addPlant: PropTypes.func.isRequired,
  updatePlant: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  plantsLoading: PropTypes.bool.isRequired,
  plantErrors: PropTypes.object.isRequired,
  clearPlantErrors: PropTypes.func.isRequired,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatch)(Plants);
